import { NgModule } from '@angular/core';
import { DialogService } from '@ngneat/dialog';

import { ConstantsService } from '~core/services/constants.service';
import { SsrResponseService } from '~core/services/ssr-response.service';
import { SsrRequestService } from '~core/services/ssr-request.service';
import { ApiConstantsService } from '~core/services/api-constants.service';
import { AccessControlsService } from '~core/services/access-controls.service';
import { ArticleService } from '~core/services/article.service';
import { AttachmentService } from '~core/services/attachment.service';
import { BadgeService } from '~core/services/badge.service';
import { BannerService } from '~core/services/banner.service';
import { BlockService } from '~core/services/block.service';
import { BroadcastPeriodService } from '~core/services/broadcast-period.service';
import { CategoryService } from '~core/services/category.service';
import { CommentService } from '~core/services/comment.service';
import { ConfigurationService } from '~core/services/configuration.service';
import { ContentService } from '~core/services/content.service';
import { ReactionService } from '~core/services/reaction.service';
import { EventService } from '~core/services/event.service';
import { FavoriteService } from '~core/services/favorite.service';
import { MonitorService } from '~core/services/monitor.service';
import { NotificationService } from '~core/services/notification.service';
import { PageService } from '~core/services/page.service';
import { ProfileService } from '~core/services/profile.service';
import { RequestService } from '~core/services/request.service';
import { SectionService } from '~core/services/section.service';
import { SsrCookieService } from '~core/services/ssr-cookie.service';
import { StorageService } from '~core/services/storage.service';
import { TagService } from '~core/services/tag.service';
import { TimeSlotService } from '~core/services/time-slot.service';
import { TvShowService } from '~core/services/tv-show.service';
import { VideoService } from '~core/services/video.service';
import { BlacklistedService } from '~core/services/blacklisted.service';

const PROVIDERS = [
  ApiConstantsService,
  ConstantsService,
  SsrRequestService,
  SsrResponseService,
  AccessControlsService,
  ArticleService,
  AttachmentService,
  BadgeService,
  BannerService,
  BlockService,
  BroadcastPeriodService,
  CategoryService,
  CommentService,
  ConfigurationService,
  ContentService,
  DialogService,
  ReactionService,
  EventService,
  FavoriteService,
  MonitorService,
  NotificationService,
  PageService,
  ProfileService,
  RequestService,
  SectionService,
  SsrCookieService,
  StorageService,
  TagService,
  TimeSlotService,
  TvShowService,
  VideoService,
  BlacklistedService
];

@NgModule({
  providers: PROVIDERS,
  exports: []
})
export class CoreModule {}
